import { useAuth, useCurrentUser } from "@hooks";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { EmptyState } from "./EmptyState";
import FullScreenLoading from "../../common/loading/FullScreenLoading";
import OrganizationPage from "../../organization";

const TeamsManagementPage = () => {
  // Hooks
  const {
    orgUuid,
    userTeams,
    refetchUserDetails,
    loading,
    error,
    isOrgAdmin,
  } = useAuth();

  const navigate = useNavigate();
  const { data: currentUser, loading: currentUserLoading } =
    useCurrentUser();

  const [firstTeamCreation, setFirstTeamCreation] = useState(
    userTeams?.length === 0,
  );

  useEffect(() => {
    if (!firstTeamCreation && userTeams?.length === 0) {
      setFirstTeamCreation(true);
    }
  }, [userTeams]);

  // If the user only has one team and they are not an org admin, redirect them
  useEffect(() => {
    if (userTeams?.length === 1 && !isOrgAdmin) {
      navigate(`/teams/${userTeams[0].uuid}`);
    }
  }, []);

  if (currentUserLoading || loading) {
    return (
      <FullScreenLoading
        loadingTrigger={currentUserLoading || loading}
      />
    );
  }

  // If the user has no teams, return an empty state
  // we intentionally use a non updating state
  // this prevents changing the component during team creation
  if (firstTeamCreation) {
    return (
      <EmptyState
        orgUuid={orgUuid}
        refetch={refetchUserDetails}
        currentUser={currentUser}
      />
    );
  }

  return (
    <OrganizationPage
      refetchTeams={refetchUserDetails}
      loadingTeams={loading}
      userTeams={userTeams}
      userTeamsError={error}
    />
  );
};

export default TeamsManagementPage;
